import styled from 'styled-components';

export const ButtonContainer = styled.div`
  height: 40px;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50%;
`;

export const HotKeysContainer = styled.div`
  padding: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  gap: 20px;
  div {
    width: 50%;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  gap: 200px;
  align-content: flex-start;
  font-size: 1.1rem;
  align-items: center;
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 380px;
  text-align: left;
  gap: 10px;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  div {
    width: 50%;
  }
`;
